import { getActiveBrandId } from "@eweadn-qiankun/shared-utils";
import type { CrossBrandBootstrapDto, CrossBrandPromptItem } from "../types";
import {
  deviceDisplayLabel,
  findSupportedDeviceRowUnfiltered,
  resolveDeviceBrandFromRow,
} from "./matchDeviceConfig";

type HidLike = {
  vendorId: number;
  productId: number;
  productName?: string;
};

export function resolveCrossBrandPromptItems(
  bootstrap: CrossBrandBootstrapDto,
  authorizedHids: HidLike[]
): CrossBrandPromptItem[] {
  const cfg = bootstrap.config;
  if (!cfg.crossBrandPromptEnabled) return [];
  const active = getActiveBrandId().trim().toLowerCase();
  const defaultBrand = (cfg.defaultBrandCode || "eweadn").trim().toLowerCase();
  if (active !== defaultBrand) return [];

  const brandMap = new Map(
    (bootstrap.brands ?? []).map((b) => [b.brandCode.trim().toLowerCase(), b])
  );

  /** 仅提示「当前最新接入」的异品牌设备（列表顺序靠后的 HID 覆盖前者） */
  let latest: CrossBrandPromptItem | null = null;

  for (const hid of authorizedHids) {
    if (typeof hid.vendorId !== "number" || typeof hid.productId !== "number") {
      continue;
    }
    const row = findSupportedDeviceRowUnfiltered(
      hid.vendorId,
      hid.productId,
      hid.productName
    );
    if (!row) continue;
    const deviceBrand = resolveDeviceBrandFromRow(row);
    if (deviceBrand === active) continue;
    const meta = brandMap.get(deviceBrand);
    if (!meta?.hubUrl) continue;

    const pair = { vendorId: hid.vendorId, productId: hid.productId };
    latest = {
      brandCode: deviceBrand,
      brandName: meta.name || deviceBrand,
      hubUrl: meta.hubUrl,
      clientDetectConfig: meta.clientDetectConfig,
      deviceLabel: deviceDisplayLabel(row),
      matchedVidPids: [pair],
    };
  }

  return latest ? [latest] : [];
}
